import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useRolesContext } from 'modules/roles/contexts';

export const useNavigation = () => {
  const history = useHistory();
  const [created, setCreated] = useState('');
  const { combinedRoles } = useRolesContext();

  useEffect(() => {
    const newRole = combinedRoles.find((role) => role.name === created);
    if (newRole) {
      history.push(`/roles/${newRole.id}`);
    }
  }, [created, combinedRoles]);

  return { setCreated };
};
